import PropTypes from 'prop-types'
import React from 'react'

import LeadApiService from '@apis/lead-api-service'
import { Alert, Box, Button, TextField, Stack } from '@components/ui'
import useForm from '@hooks/use-form'
import usePromise, { STATUS_MAP } from '@hooks/use-promise'
import { values, validations } from '@models/lead'

const EmailForm = ({ onCreate }) => {
  const { textFieldProps, handleFormSubmit } = useForm(values, validations)

  const [createRequest, createPromise] = usePromise((params) =>
    LeadApiService.addLead(params).then(onCreate)
  )

  return (
    <Box sx={{ maxWidth: 300, width: '100%' }}>
      <form onSubmit={handleFormSubmit(createPromise)}>
        <Stack spacing={4}>
          <Box>
            <TextField label="Email" {...textFieldProps('email')} />
          </Box>
          <Box>
            <Button
              disabled={STATUS_MAP.pending === createRequest.status}
              sx={{ width: '100%' }}
              type="submit"
            >
              Submit
            </Button>
          </Box>
          {STATUS_MAP.error === createRequest.status && (
            <Box>
              <Alert severity="error">{createRequest.error}</Alert>
            </Box>
          )}
        </Stack>
      </form>
    </Box>
  )
}

EmailForm.propTypes = {
  onCreate: PropTypes.func.isRequired,
}

export default EmailForm
